import request from '@/utils/request'

// 模拟post请求--带参数
export function getImageUrl(imagetype, data) {
    return request({
        url: '/api/images/' + imagetype,
        method: 'post',
        params: data
    })
}
export function gethistoryAndFav(data) {
    return request({
        url:'/api/videocount/historyorfav',
        method:'post',
        params: data
    })
}

